import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useStore from "../../../context/useStore";
import tools from "../../../helpers/tools";
import { ResultsCard } from "../../common/DataList";
import useOrganizations from "../../Hooks/useOrganizations/useOrganizations";
import useRecipientStock from "./useRecipientStock";

const COUNT_LABELS = {
  none: "Aucun allocataire du stock trouvé",
  one: "allocataire du stock trouvé",
  many: "allocataires du stock trouvés",
};

const RecipientStockTable = () => {
  const [state] = useStore();
  const { EP_TYPES } = state.constants.items;
  const { organizations, onGetOrganizations } = useOrganizations();
  const {
    recipientStock,
    isLoadingRecipientStock,
    recipientStockFilters,
    nbResults,
    nbPages,
    hasSearched,
    changePage,
    changeNbItemsByPage,
  } = useRecipientStock();

  useEffect(() => {
    onGetOrganizations();
  }, []);

  return (
    <ResultsCard
      caption="Liste des allocataires du stock"
      rows={recipientStock}
      count={nbResults}
      countLabels={COUNT_LABELS}
      hasSearched={hasSearched}
      isLoading={isLoadingRecipientStock}
      page={recipientStockFilters.page}
      nbPages={nbPages}
      nbItemsByPage={recipientStockFilters.nbItemsByPage}
      onChangePage={changePage}
      onChangeNbItemsByPage={changeNbItemsByPage}
      itemLabel="allocataires"
      fields={[
        {
          name: "Nom",
          path: "*",
          exportPath: "name",
          render: (el) => (
            <Link to={`recipients-stock/${el.id}`} className="recipient-name">
              {tools.getFullname(el)}
            </Link>
          ),
        },
        {
          name: "NIR",
          path: "nir",
        },
        {
          name: "Matr.",
          path: "CAFId",
        },
        {
          name: "Email",
          path: "*",
          exportPath: "email",
          render: (el) => (
            <div>
              <a href={`mailto: ${el.email}`} style={{ color: "inherit" }}>
                {el.email}
              </a>
            </div>
          ),
        },
        {
          name: "Tél",
          path: "phone",
        },
        {
          name: "Orientation",
          path: "orientation",
          render: (el) =>
            el ? (
              <div>
                <small>Orienté le {tools.formatDate(el.createdAt)} vers</small>{" "}
                {organizations.find((m) => m.slugName == el.orientation).name}
              </div>
            ) : (
              "-"
            ),
        },
        {
          name: "Procédure",
          path: "*",
          render: (el) => {
            let content = [];
            if (el.epDetail?.EP) {
              content.push(
                <div>
                  Inscrit EP du {tools.formatDate(el.epDetail.EP.beginAt)} pour{" "}
                  {tools.findIn(EP_TYPES, "id", el.epDetail.type).name}
                </div>
              );
            }
            if (el.reorientation?.createdAt) {
              content.push(
                <div>
                  Réo en cours depuis{" "}
                  {tools.formatDate(el.reorientation.createdAt)} vers{" "}
                  {
                    tools.findIn(
                      organizations,
                      "id",
                      el.reorientation.toPartner
                    ).name
                  }
                </div>
              );
            }

            return content;
          },
        },
        {
          name: "Voir",
          path: "id",
          render: (el) => (
            <Link
              to={"/recipients-stock/" + el}
              className="btn btn-primary w-100 btn-sm d-flex align-items-center justify-content-center"
            >
              <i className="fa fa-eye"></i>
            </Link>
          ),
        },
      ]}
    />
  );
};

export default RecipientStockTable;
